import { RawScrapejobSummaryData } from './types';

export class ScrapejobSummaryModel {
  id: string;
  startTime: string;
  endTime: string;
  status: string;
  site: string;
  siteId: string;
  itemIds: string[];
  listingIds: string[];
  image: string;

  constructor(rawScrapejobData: RawScrapejobSummaryData, image: string = '') {
    this.id = rawScrapejobData.id;
    this.startTime = rawScrapejobData.start_time;
    this.endTime = rawScrapejobData.end_time;
    this.status = rawScrapejobData.status;

    // Handle site being either a string (site ID) or a site object
    if (typeof rawScrapejobData.site === 'string') {
      this.site = rawScrapejobData.site;
      this.siteId = rawScrapejobData.site_id;
      this.image = image;
    } else {
      this.site = rawScrapejobData.site.name;
      this.siteId = rawScrapejobData.site.id;
      this.image = rawScrapejobData.site.image;
    }

    this.itemIds = rawScrapejobData.item_ids || [];
    this.listingIds = rawScrapejobData.listing_ids || [];
  }

  getProcessCardFormat() {
    const baseType = this.itemIds.length > 0 ? 'Items' : 'Listings';
    const baseCount = this.itemIds.length || this.listingIds.length;
    return {
      id: this.id,
      name: this.site,
      status: this.status,
      image: this.image,
      baseType: baseType,
      baseCount: baseCount
    };
  }
}
